
import { useLocation, Navigate, Outlet } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import type { IAppState } from "../core/redux/IAppState";
import { getRequiredRolesForPath } from "./routeRoleAccessMap";


export default function RequireRole() {
  const location = useLocation();

  const requiredRoles = useSelector((s: IAppState) => getRequiredRolesForPath(s, location.pathname));
  const userRoles = useSelector((s: IAppState) => s.userState?.role ? [s.userState.role] : ["agent"], shallowEqual);
  
  // No rule → allow
  if (!requiredRoles || requiredRoles.length === 0) {
    return <Outlet />;
  }

  const isAllowed = requiredRoles.some(role =>
    userRoles.includes(role)
  );

  if (!isAllowed) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
}
